import React, { useEffect, useState } from "react";
import { DumpProvider } from "./DumpContext";
import DumpFileList from "./DumpFileList";
import DumpCreateModal from "./DumpCreateModal";
// import DumpTableSelector from "./DumpTableSelector";
// 🔜 позже сюда добавим SchedulerTasks, SchedulerTaskForm, DumpList

export default function DumpManager() {
    const [showModal, setShowModal] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const refreshFileList = () => {
        setRefreshKey(prev => prev + 1);
      };

  return (
    <DumpProvider>
      <div style={{ padding: "10px" }}>
      <DumpFileList key={refreshKey} />
        <button onClick={() => setShowModal(true)}>➕ Создать дамп</button>
        {/* <DumpTableSelector /> */}
        {/* другие компоненты: */}
        {/* <SchedulerTasks /> */}
        {/* <SchedulerTaskForm /> */}
        {/* <DumpList /> */}
        {showModal && (
        <DumpCreateModal
          onClose={() => setShowModal(false)}
          onCreated={refreshFileList}
        />
      )}
      </div>

    </DumpProvider>
  );
}
